export default __webpack_public_path__ + "static/media/certificate.98c3f0a9.jpg";